// Default cover image for posts without a cover
export const DEFAULT_COVER_IMAGE = 'https://lordglennchen.ddns.net/flickr/53967989023';
